import { render, staticRenderFns } from "./TotalAmountsBase.vue?vue&type=template&id=736baf3f&scoped=true&"
import script from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
export * from "./TotalAmountsBase.vue?vue&type=script&lang=js&"
import style0 from "./TotalAmountsBase.vue?vue&type=style&index=0&id=736baf3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736baf3f",
  null
  
)

export default component.exports